/* Reviews "Write A Review" → open the write-a-review modal.

   The reviews snippet (Spectrum sai-d1odzamh) renders its own "Write A Review"
   button inside .sai-d1odzamh__summary-actions, but it is just an anchor to the
   "/#write-review" placeholder. The actual write-a-review form is a separate
   Spectrum snippet (sai-rvwfrm01) rendered in its own slot with a modal trigger
   (.sai-rvwfrm01__trigger).

   This shim wires the review-summary button to open that modal — by
   programmatically clicking the real trigger, so Spectrum's own open logic and
   DOM stay untouched — and hides the standalone trigger so the review summary is
   the single entry point. Both snippets are Spectrum-generated; doing this in a
   theme asset avoids editing the generated files (which can be regenerated). */
(function () {
  if (window.__spectrumReviewWriteTrigger) return;
  window.__spectrumReviewWriteTrigger = true;

  var TRIGGER_SEL = '.sai-rvwfrm01__trigger, [data-rvw-trigger]';
  var WRITE_BTN_SEL =
    '.sai-d1odzamh__write-btn, .sai-d1odzamh__summary-actions [data-action="write-review"]';

  function reviewSummaryPresent() {
    return !!document.querySelector('.sai-d1odzamh__write-btn');
  }

  // Visually hide the form's own trigger (kept in the DOM and clickable so its
  // Spectrum click handler still runs when we drive it). Only do this where the
  // review summary exists, so pages that legitimately show the standalone form
  // (e.g. a dedicated write-a-review page) are left alone.
  function hideStandaloneTriggers() {
    if (!reviewSummaryPresent()) return;
    document.querySelectorAll(TRIGGER_SEL).forEach(function (t) {
      if (t.dataset.spectrumWired === '1') return;
      t.dataset.spectrumWired = '1';
      t.style.position = 'absolute';
      t.style.width = '1px';
      t.style.height = '1px';
      t.style.padding = '0';
      t.style.margin = '-1px';
      t.style.overflow = 'hidden';
      t.style.clip = 'rect(0 0 0 0)';
      t.style.clipPath = 'inset(50%)';
      t.style.border = '0';
    });
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    var btn = target && target.closest ? target.closest(WRITE_BTN_SEL) : null;
    if (!btn) return;
    var trigger = document.querySelector(TRIGGER_SEL);
    if (!trigger) return; // no form on this page — let the link behave normally
    e.preventDefault();
    trigger.click();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideStandaloneTriggers);
  } else {
    hideStandaloneTriggers();
  }

  // The reviews/form snippets hydrate and can re-render for a short window after
  // load; re-apply the hide (debounced) while that settles. Crucially this
  // observer is BOUNDED: watching the whole document subtree for the life of
  // every page (most of which have no reviews) is the cost this file must not
  // pay. Stop as soon as the summary is up and every trigger is wired, or after
  // a grace cap if reviews never render here — so it only runs during initial
  // hydration, not for the page's lifetime. The per-node guard keeps each pass
  // cheap. Scoped to <body>, not documentElement, so <head> churn (lazy
  // stylesheet/script injection) doesn't wake it.
  // Settled = the review UI has finished hydrating: the summary is up, at least
  // one trigger has actually been wired, and none are left unwired. Requiring a
  // *wired* trigger (not merely "no unwired ones") avoids disconnecting in the
  // gap where the summary has rendered but the form trigger hasn't yet — which
  // would leave a late-arriving trigger unhidden.
  function settled() {
    return reviewSummaryPresent()
      && !!document.querySelector(TRIGGER_SEL.split(', ').map(function (s) { return s + '[data-spectrum-wired="1"]'; }).join(', '))
      && !document.querySelector(TRIGGER_SEL.split(', ').map(function (s) { return s + ':not([data-spectrum-wired="1"])'; }).join(', '));
  }

  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      hideStandaloneTriggers();
      if (settled()) observer.disconnect();
    });
  });

  if (!settled()) {
    observer.observe(document.body, { childList: true, subtree: true });
    // Reviews hydrate within a few seconds; if nothing relevant appears, stop
    // watching rather than persist. A late re-render (e.g. after submitting a
    // review) is re-hidden by the click handler above driving the summary path.
    setTimeout(function () { observer.disconnect(); }, 12000);
  }
})();
